// Builds partner booking URLs using each site's verified search format,
// pre-filling place, dates and travelers where the partner supports it.

const MONTHS_FULL = [
  "january", "february", "march", "april", "may", "june",
  "july", "august", "september", "october", "november", "december",
];
const MONTHS_ABBR = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

const parts = (d) => {
  const [y, m, day] = d.split("-").map(Number);
  return { y, m, day };
};
const monthYear = (d) => {
  const { y, m } = parts(d);
  return `${MONTHS_FULL[m - 1]}-${y}`;
};
const ddMonYYYY = (d) => {
  const { y, m, day } = parts(d);
  return `${String(day).padStart(2, "0")} ${MONTHS_ABBR[m - 1]} ${y}`;
};
const countryOf = (country) =>
  (country.includes(",") ? country.split(",").pop() : country).trim();

// Open a partner link in a new tab WITHOUT ever navigating the current/top tab.
// Note: passing "noopener" to window.open makes it return null, which previously
// triggered a top-location fallback that redirected the original tab — avoid that.
export const openExternal = (link) => {
  const w = window.open(link, "_blank");
  if (w) {
    try { w.opener = null; } catch (_) { /* cross-origin, ignore */ }
    return;
  }
  // Popup blocked: open via a transient anchor (still never touches this tab).
  const a = document.createElement("a");
  a.href = link;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const buildPartnerUrl = ({
  partner,
  title,
  country,
  query,
  bookType,
  from,
  to,
  adults = 2,
  children = 0,
}) => {
  const place = country && country !== title ? `${title} ${country}` : title;
  // Search term aligned to the specific card the user clicked (e.g. "island hopping Santorini Greece").
  const term = query ? `${query} ${place}` : place;

  if (partner === "TourRadar") {
    const base = `https://www.tourradar.com/search?q=${encodeURIComponent(term)}`;
    if (from) return `${base}#month=${monthYear(from)},adults=${adults},children=${children}`;
    return base;
  }

  if (partner === "Intrepid Travel") {
    let u = `https://www.intrepidtravel.com/eu/search?page=1&sort=relevance&keyword=${encodeURIComponent(term)}`;
    if (from && to) {
      u += `&date_range_from=${encodeURIComponent(ddMonYYYY(from))}&date_range_to=${encodeURIComponent(ddMonYYYY(to))}`;
    }
    return u;
  }

  if (partner === "BookRetreats") {
    let u = `https://www.bookretreats.com/search?scopes[location]=${encodeURIComponent(countryOf(country))}&scopes[type]=${encodeURIComponent(bookType || "Yoga Retreats")}`;
    if (from && to) {
      u += `&ranges[dates.days][min]=${from}&ranges[dates.days][max]=${to}`;
    }
    return `${u}&pageNumber=1`;
  }

  // GetYourGuide
  let u = `https://www.getyourguide.com/s/?q=${encodeURIComponent(term)}`;
  if (from && to) u += `&date_from=${from}&date_to=${to}`;
  u += `&adults=${adults}`;
  return u;
};
